import { createAction, props } from '@ngrx/store';
import { RemoteAccessResponseSuccess } from '../../model/remote-access.model';
import { RemoteSendOtpResponseSuccess } from '../../model/remote-send-otp.model';
import { RemoteCheckSmsTokenResponseSuccess } from '../../model/remote-check-sms-token.model';
import { ProcessActions } from '../process/process.actions';
import AppError from 'src/app/model/app-error';

export enum RemoteActions {
  Reset = '[Remote] Reset',
  InitStart = '[Remote] Init Start',
  InitSuccess = '[Remote] Init Success',
  InitError = '[Remote] Init Error',
  SendSmsTokenStart = '[Remote] Send Sms Token Start',
  SendSmsTokenSuccess = '[Remote] Send Sms Token Success',
  SendSmsTokenError = '[Remote] Send Sms Token Error',
  VerifySmsTokenStart = '[Remote] Verify Sms Token Start',
  VerifySmsTokenSuccess = '[Remote] Verify Sms Token Success',
  VerifySmsTokenError = '[Remote] Verify Sms Token Error',
  PushNavigationError = '[Process] Push navigation error',
  ResetNavigationError = '[Process] Reset navigation error',
  SetRemoteId = '[Process] Set remote id',
}

const reset = createAction(RemoteActions.Reset);

const initStart = createAction(RemoteActions.InitStart, props<{ id: string }>());
const initSuccess = createAction(RemoteActions.InitSuccess, props<{ success: RemoteAccessResponseSuccess }>());
const initError = createAction(RemoteActions.InitError, props<{ error: AppError | null }>());

const sendSmsTokenStart = createAction(RemoteActions.SendSmsTokenStart, props<{ id: string }>());
const sendSmsTokenSuccess = createAction(RemoteActions.SendSmsTokenSuccess, props<{ success: RemoteSendOtpResponseSuccess }>());
const sendSmsTokenError = createAction(RemoteActions.SendSmsTokenError, props<{ error: AppError | null }>());

const verifySmsTokenStart = createAction(RemoteActions.VerifySmsTokenStart, props<{ id: string; otp: string }>());
const verifySmsTokenSuccess = createAction(RemoteActions.VerifySmsTokenSuccess, props<{ success: RemoteCheckSmsTokenResponseSuccess }>());
const verifySmsTokenError = createAction(RemoteActions.VerifySmsTokenError, props<{ error: AppError | null }>());

const setRemoteId = createAction(RemoteActions.SetRemoteId, props<{ remoteId: string | null }>());

const pushNavigationError = createAction(ProcessActions.PushNavigationError, props<{ error: string; preserve?: boolean }>());
const resetNavigationError = createAction(ProcessActions.ResetNavigationError);

const remoteActions = {
  reset,
  initStart,
  initSuccess,
  initError,
  sendSmsTokenStart,
  sendSmsTokenSuccess,
  sendSmsTokenError,
  verifySmsTokenStart,
  verifySmsTokenSuccess,
  verifySmsTokenError,
  pushNavigationError,
  resetNavigationError,
  setRemoteId,
};

export default remoteActions;
